import React, { useState } from 'react';
import {
  Box,
  Tabs,
  Tab,
  Paper,
} from '@mui/material';
import { People as PeopleIcon, Security as SecurityIcon } from '@mui/icons-material';
import UsersList from './UsersList';
import RolesList from './RolesList';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`users-tabpanel-${index}`}
      aria-labelledby={`users-tab-${index}`}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
};

const Users: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Box>
      <Paper sx={{ mb: 3 }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="user management tabs"
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab
            icon={<PeopleIcon />}
            label="Usuarios"
            id="users-tab-0"
            aria-controls="users-tabpanel-0"
            iconPosition="start"
          />
          <Tab
            icon={<SecurityIcon />}
            label="Roles y Permisos"
            id="users-tab-1"
            aria-controls="users-tabpanel-1"
            iconPosition="start"
          />
        </Tabs>
      </Paper>

      <TabPanel value={tabValue} index={0}>
        <UsersList />
      </TabPanel>
      
      <TabPanel value={tabValue} index={1}>
        <RolesList />
      </TabPanel>
    </Box>
  );
};

export default Users;